module.exports = __webpack_public_path__ + "img/pennellata-titolo.fa91b165.png";